/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Membership_Confirmations_Resources_AllocatedInputs */

const en_admin_membership_confirmations_resources_allocated = /** @type {(inputs: Admin_Membership_Confirmations_Resources_AllocatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`This member has ${i?.count} resource allocated:`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`This member has ${i?.count} resources allocated:`);
	return /** @type {LocalizedString} */ ("admin.membership_confirmations.resources_allocated");
};

const de_admin_membership_confirmations_resources_allocated = /** @type {(inputs: Admin_Membership_Confirmations_Resources_AllocatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Dieses Mitglied hat ${i?.count} zugewiesene Ressource:`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Dieses Mitglied hat ${i?.count} zugewiesene Ressourcen:`);
	return /** @type {LocalizedString} */ ("admin.membership_confirmations.resources_allocated");
};

const es_admin_membership_confirmations_resources_allocated = /** @type {(inputs: Admin_Membership_Confirmations_Resources_AllocatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Este miembro tiene ${i?.count} recurso asignado:`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Este miembro tiene ${i?.count} recursos asignados:`);
	return /** @type {LocalizedString} */ ("admin.membership_confirmations.resources_allocated");
};

const fr_admin_membership_confirmations_resources_allocated = /** @type {(inputs: Admin_Membership_Confirmations_Resources_AllocatedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Ce membre a ${i?.count} ressource attribuée :`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Ce membre a ${i?.count} ressources attribuées :`);
	return /** @type {LocalizedString} */ ("admin.membership_confirmations.resources_allocated");
};

/** @type {(inputs: Admin_Membership_Confirmations_Resources_AllocatedInputs) => LocalizedString} */
const it_admin_membership_confirmations_resources_allocated = en_admin_membership_confirmations_resources_allocated;

/** @type {(inputs: Admin_Membership_Confirmations_Resources_AllocatedInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_resources_allocated = en_admin_membership_confirmations_resources_allocated;

/** @type {(inputs: Admin_Membership_Confirmations_Resources_AllocatedInputs) => LocalizedString} */
const pl_admin_membership_confirmations_resources_allocated = en_admin_membership_confirmations_resources_allocated;

/** @type {(inputs: Admin_Membership_Confirmations_Resources_AllocatedInputs) => LocalizedString} */
const hu_admin_membership_confirmations_resources_allocated = en_admin_membership_confirmations_resources_allocated;

/** @type {(inputs: Admin_Membership_Confirmations_Resources_AllocatedInputs) => LocalizedString} */
const ro_admin_membership_confirmations_resources_allocated = en_admin_membership_confirmations_resources_allocated;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "This member has {count} resource allocated:" |
* | "other" | "This member has {count} resources allocated:" |
*
* @param {Admin_Membership_Confirmations_Resources_AllocatedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_resources_allocated = /** @type {((inputs: Admin_Membership_Confirmations_Resources_AllocatedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Resources_AllocatedInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_resources_allocated(inputs)
	if (locale === "de") return de_admin_membership_confirmations_resources_allocated(inputs)
	if (locale === "es") return es_admin_membership_confirmations_resources_allocated(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_resources_allocated(inputs)
	if (locale === "it") return it_admin_membership_confirmations_resources_allocated(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_resources_allocated(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_resources_allocated(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_resources_allocated(inputs)
	return ro_admin_membership_confirmations_resources_allocated(inputs)
});
export { admin_membership_confirmations_resources_allocated as "admin.membership_confirmations.resources_allocated" }